export const Positions = [
    "general.positions.physician",
    "general.positions.physicianAssistant",
    "general.positions.nurse",
    "general.positions.nursePractitioner",
    "general.positions.technician",
    "general.positions.administrator",
    "general.positions.other",
]